export enum ApplicationName {
    Dashboard = "Dashboard",
    Maps = "Maps",
    Schedule = "Schedule",
    People = "People",
    Settings = "Settings"
}